// extracted by mini-css-extract-plugin
export default {"icon":"Uu5wi","link":"xvJov","sizeInfo":"NDYl0"};